import React, { memo } from 'react';
import { type MDIIconProps } from './MDIIcon.types';

const DEFAULT_SIZE = 24;
/**
 * Renders a Material Design icon, scaled to the specified size.
 */
const MDIIcon: React.FC<MDIIconProps> = memo((props) => {
  const { icon: Icon, size, fill } = props;

  const height = props.height || size;
  const width = props.width || size;

  const style = {
    ...props.style,
    fill,
    height: height ? `${height}px` : undefined,
    width: width ? `${width}px` : undefined,
  };

  const className = props.className ?? '';

  return (
    <Icon
      className={`icon ${className}`}
      style={style}
      width={width ? undefined : DEFAULT_SIZE}
      height={height ? undefined : DEFAULT_SIZE}
    />
  );
});

MDIIcon.displayName = 'MDIIcon';

export default MDIIcon;
